enum BorrowerCategoryEnum {
    Borrower = 'BORROWER',
    Guarantor = 'GUARANTOR',
}

export default BorrowerCategoryEnum;
